export class Tag {
    name: string;

    constructor(name: string) {
        this.name = name;
    }
}
